import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {AccessPermission, Collection, CollectionAccessUpdate} from "../../collection.model";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatButton, MatIconButton} from "@angular/material/button";
import {CollectionService} from "../../collection.service";
import {TranslatePipe} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";

@Component({
    selector: 'app-collection-share-status',
    imports: [
        MatMenu,
        MatButton,
        MatMenuTrigger,
        MatMenuItem,
        TranslatePipe,
        MatIcon,
        MatIconButton,
        MatDialogContent
    ],
    templateUrl: './collection-access.component.html',
    styleUrl: './collection-access.component.scss'
})
export class CollectionAccessComponent {

    collection: Collection;
    error: string | null = null;

    constructor(
        private collectionService: CollectionService,
        private dialogRef: MatDialogRef<CollectionAccessComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Collection,
    ) {
        this.collection = data;
    }

    changeAccess(accessId: number, permission: AccessPermission) {
        let access: CollectionAccessUpdate = {
            accessId: accessId,
            permission: permission
        }
        this.collectionService.updateUserAccessToCollection(this.data.uuid, access).subscribe({
            next: (collection) => {
                this.collection = collection;
            },
            error: (e) => {
                console.error(e);
                this.error = 'Error updating access';
            }
        });
    }

    removeAccess(accessId: number) {
        this.collectionService.removeUserAccessFromCollection(this.data.uuid, accessId).subscribe({
            next: col => {
                this.collection = col;
            },
            error: (e) => {
                console.error(e);
                this.error = 'Error removing access';
            }
        });
    }

    close() {
        this.dialogRef.close(this.collection);
    }
}
